import Enum from './enum'

class ProtocolType extends Enum
{
  constructor(value) {
    super(value);
  }
}

ProtocolType.init({
  RECEIVING_REQUESTS: 'GettingRequest',
  PROCESSING_REQUESTS: 'ProcessingRequest',
  PROCESSING_REQUESTS_BY_CRITERION: 'ProcessingRequestByCriterion',
  RETEND: 'Retend',
  SPLITTING_PRCE: 'DividingPrice',
  ACCEPT: 'Accept',
  RESULT: 'Result'
}, {
  RECEIVING_REQUESTS: 'protocol-type.receiving-requests',
  PROCESSING_REQUESTS: 'protocol-type.processing-requests',
  PROCESSING_REQUESTS_BY_CRITERION: 'protocol-type.processing-requests-by-criterion',
  RETEND: 'protocol-type.retend',
  SPLITTING_PRICE: 'protocol-type.splitting-price',
  ACCEPT: 'protocol-type.accept',
  RESULT: 'protocol-type.result'
});

export default ProtocolType;
